/* eslint-disable no-unused-vars */
function initSmallLayoutAnimations() {
  // Standard to top link animation
  $('.top-link').on('click', () => {
    $('body,html').animate({
      scrollTop: 0,
    }, 800);
  });
}

function handleScroll() {
  const scrollToTopBtn = document.getElementById('scrollToTopBtn');
  if (scrollToTopBtn) {
    const rootElement = document.documentElement;
    if ((rootElement.scrollTop / window.innerHeight) > 0.7) {
      // Show button
      scrollToTopBtn.classList.remove('disabled');
    } else {
      // Hide button
      scrollToTopBtn.classList.add('disabled');
    }
  }
}

handleScroll();
document.addEventListener('scroll', handleScroll);
